import { jsx } from 'react/jsx-runtime';
import { createGlobalReferenceContext } from '@flex-packages/shared-react';
import { useContext, useMemo } from 'react';

const EventFeatureContext = createGlobalReferenceContext("event-feature-context", {
  eventFeature: ""
});
const EventFeatureBoundaryContext = ({
  eventFeature,
  children
}) => {
  const value = useMemo(
    /**
     * EventFeatureContext는 제품 내 수많은 UI에서 참조되고 있기 때문에
     * 아래 `value` prop으로 들어가는 값이 불필요하게 변경되지 않는 것을 보장해줘야한다.
     */
    () => ({ eventFeature }),
    [eventFeature]
  );
  return /* @__PURE__ */ jsx(EventFeatureContext.Provider, { value, children });
};
const useEventFeatureBoundary = () => {
  const ctx = useContext(EventFeatureContext);
  if (ctx.eventFeature === "") {
    console.warn("EventFeatureBoundary \uD558\uC704 \uCEF4\uD3EC\uB10C\uD2B8\uC5D0\uC11C \uC0AC\uC6A9\uD574\uC8FC\uC138\uC694.");
  }
  return ctx;
};

export { EventFeatureBoundaryContext, EventFeatureContext, useEventFeatureBoundary };
//# sourceMappingURL=eventFeatureBoundaryContext.mjs.map
